export default "__VITE_ASSET__Dez6VqbB__"